module.exports = __webpack_public_path__ + "media/rainforest.08ed9e34.jpg";